import {AfterViewInit, Component, HostListener, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-kashcash-dialog',
    templateUrl: './kashcash-dialog.component.html',
    styleUrl: './kashcash-dialog.component.scss',
    standalone: false
})
export class KashcashDialogComponent implements AfterViewInit{
	@HostListener('window:message', ['$event'])
	onMessage(e) {
		this.onFrameMessage(e.data );
	}
	trustedIframeUrl: SafeResourceUrl;
	mobilePaymentUrl;

	constructor(
		private sanitizer: DomSanitizer,
		public appService: AppService,
		public dialogRef: MatDialogRef<KashcashDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.trustedIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.setup.paymentUrl);
		this.mobilePaymentUrl = this.data.setup.mobilePaymentUrl;
		if (
			navigator.userAgent.match(/Android/i)
			// || navigator.userAgent.match(/iPhone/i)
		) {

		}
	}

	ngAfterViewInit() {
		if (this.mobilePaymentUrl) {
			this.openExternalApp();
		}
	}

	onFrameMessage(data: any) {
		console.log("KASHCASH RESPONSE", data);
		if (data && data.status && data.transactionId) {
			let result;
			switch (data.status) {
				case 1:
					this.apply();
					return;
				case 2: //Canceled

					break;
				case 3://Rejected

					break;
				default:
			}
			this.close();
		}
	}

	openExternalApp() {
		window.open(this.mobilePaymentUrl, '_blank');
	}

	apply() {
		this.dialogRef.close({ mode: "success" });
	}

	close() {
		this.dialogRef.close({ mode: "cancel" });
	}
}
